// 部门扩展
import axios from "../axios";
import Vue from 'vue'

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}


/**
 * 查询会员单位会费缴纳统计明细表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getPaymentOfMembershipFeeDetailReport = data => {
  return axios({
    url: '/report/getPaymentOfMembershipFeeDetailReport',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const exportPaymentOfMembershipFeeDetailReport = (data, name) => {
  return axios({
    url: '/report/exportPaymentOfMembershipFeeDetailReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}
export const getPaymentOfMembershipFeeCategoryReport = data => {
  return axios({
    url: 'report/getPaymentOfMembershipFeeCategoryReport',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const downloadPaymentOfMembershipFeeCategoryReport = (data, name) => {
  return axios({
    url: '/report/downloadPaymentOfMembershipFeeCategoryReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}
/**
 * 下载新增会员单位发展情况表
 * @param data
 * @param name
 * @returns {Promise<T | never>}
 */
export const downloadAddMemberReport = (data, name) => {
  return axios({
    url: '/report/downloadAddMemberReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


/**
 * 会员信息变更统计表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getMemberChangeReport = data => {
  return axios({
    url: 'report/getMemberChangeReport',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 会员信息变更统计表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getCurrMemberChangeReport = data => {
  return axios({
    url: 'report/getCurrMemberChangeReport',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 下载会员信息变更统计表
 * @param data
 * @param name
 * @returns {Promise<T | never>}
 */
export const downloadMemberChangeReport = (data, name) => {
  return axios({
    url: '/report/downloadMemberChangeReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/report.js